module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp23_5010.c46ac541.png";